<template>
    <b-container fluid class="h-100 img-bg">
        <b-row v-if="isvalid" no-gutters class="h-100 mainrow">
            <b-col xl="1">
            </b-col>
            <b-col class="d-lg-none" style="max-height:100px;">
                <div class="panel mobile-header" >
                    <b-button v-b-toggle.sidebar-1 class="help" variant="outline-dark" size="sm"><b-icon-info-circle></b-icon-info-circle></b-button>
                    <b-img src="NS_logo_horizontal.png" class="sidebar-logo"/>
                </div>
            </b-col>
            <b-col lg class="tour-column">
                <div class="panel tour-container">
                    <div class="tileTitle">{{currentnode}}</div>
                    <div id="tour-div">
                        <marzipano-viewer ref="pano_view" width="100%" height="100%" tour_folder="Virtual Tour" tour_xml="pano.xml" class="tour" @panoready="panoIsReady"></marzipano-viewer>
                    </div>
                </div>
            </b-col>
            <b-col lg="2" class="sidebar" style="overflow:hidden; max-height:100%">
                <div class="panel sidebar-header d-none d-lg-block">
                    <b-button v-b-toggle.sidebar-1 class="help" variant="outline-dark" size="sm"><b-icon-info-circle></b-icon-info-circle></b-button>
                    <b-img src="NS_logo.png" class="sidebar-logo"/>
                </div>
                <div class="panel">
                    <UserList ref="userlist" @guide_online="setGuideReady"></UserList>
                </div>
                <div class="toolbox panel">
                    <b-button v-if="question_going" disabled variant="warning" class="questionbutton" >Sei collegato</b-button>
                    <b-button v-else-if="!question_wtg" variant="success" class="questionbutton" @click="hostrequest">Prenota Domanda</b-button>
                    <b-button v-else disabled variant="success" class="questionbutton">Attendi di essere collegato</b-button>
                    <chat-box ref="chatbox" @message="sendChatMessage" :username="uid" class="chatbox"></chat-box>
                </div>
            </b-col>
            <b-col xl="1">
            </b-col>
        </b-row>
        <b-row v-else no-gutters>
        </b-row>

        <b-sidebar id="sidebar-1" title="Informazioni" shadow width="300px">
            <b-container fluid class="h-100" style="padding:0 10px 0 10px">
                <b-row>
                    <Agora_RTM ref="artm" :username="agora_uid" :channel="channel" @command="onCommand" @publishmembers="connectRTC" @memberJoin="memberJoin" @memberLeft="memberLeft"></Agora_RTM>
                </b-row>
                <b-row>
                    <Agora_RTC ref="artc" :username="agora_uid" :channel="channel" :preferredinput="selectedDevice != null ? selectedDevice.deviceId : null" @stream-started="registerstream" @stream-stopped="unregisterstream" @audio-devices="gotDevices"></Agora_RTC>
                </b-row>
                <b-row>
                    <hr>
                </b-row>
                <b-row>
                    <b-col>
                        <span style="font-size:0.8em">
                            {{ browserinfo }}
                            <br>
                            {{ osinfo }}
                        </span>
                        <br>
                        <b-button size="sm" variant="primary" @click="sendinfo">Invia info</b-button>
                    </b-col>
                </b-row>
            </b-container>
        </b-sidebar>

        <b-modal ref="welcome-modal" size="xl"
                 no-close-on-esc
                 no-close-on-backdrop
                 hide-header-close
                 ok-only
                 centered>

            <template v-slot:default>
                <b-container fluid class="w-100">
                    <b-row v-if="isvalid && browserOk" no-gutters>
                        <b-col sm>
                            <div style="width: 180px; margin: 0px auto; text-align: center;">
                                <h6>Mancano ancora</h6>
                                <count-down ref="countdown" :deadline="timeofevent" @finished="endCountdown"></count-down>
                                <h6> all'inizio del tour </h6>
                            </div>
                        </b-col>
                        <b-col sm class="d-lg-none">
                            <hr>
                        </b-col>
                        <b-col sm="8" class="body-content">
                            <h5>Mentre aspetti:</h5>
                            <ul>
                                <li>
                                    <div>Assicurati che il volume dell'audio sia adeguato </div>
                                    <audio controls>
                                        <source src="sample.mp3" type="audio/mpeg">
                                        Your browser does not support the audio element.
                                    </audio>
                                </li>
                                <li>
                                    <div>Assicurati che il microfono sia acceso/collegato se vuoi fare delle domande alla guida</div>
                                    <b-button-toolbar key-nav aria-label="Toolbar with button groups">
                                        <b-form-select v-model="selectedDevice" :options="audioInputDevices" default="seleziona il microfono dall'elenco" size="sm"></b-form-select>
                                        <b-button size="sm" :disabled="mictestinterval !== null || !selectedDevice" variant="outline-dark"><b-icon-play-fill @click="startTestDevice"></b-icon-play-fill></b-button>
                                        <b-button size="sm" :disabled="mictestinterval === null" variant="outline-dark"><b-icon-stop-fill @click="stopTestDevice"></b-icon-stop-fill></b-button>
                                        <b-icon-mic-fill class="mt-2"></b-icon-mic-fill>
                                        <b-progress :value="audiotestlevel * 100" :max="100" class="mt-2" style="width:10%; min-width:100px;" variant="success"></b-progress>
                                    </b-button-toolbar>
                                    <div id="mic-test"></div>
                                </li>
                            </ul>
                        </b-col>
                    </b-row>
                    <b-row v-else>
                        <b-col v-if="browserOk">
                            <h3 v-if="isused"> Biglietto usato </h3>
                            <h3 v-else-if="expired">Questo biglietto è datato: {{timeofevent}}</h3>
                            <h3 v-else-if="notyet">Questo tour inizierà {{notyet}}, ricollegati più tardi</h3>
                            <h3 v-else> Caricamento </h3>
                        </b-col>
                        <b-col v-else>
                            <h3>Il browser in uso non supporta alcune delle funzioni necessarie per la fruizione del tour</h3>
                            <h4>Ricollegati da desktop con:</h4>
                            <ul>
                                <li>Chrome v.80+, Firefox v.70+ su Windows (Edge v.80+ su Windows 10)</li>
                                <li>Chrome v.80+, Firefox v.70+, Safari v.11+ su macOS</li>
                            </ul>
                            <h4>o mobile con:</h4>
                            <ul>
                                <li>Safari v.11+ su IOS</li>
                                <li>Chrome v.80+ su Android</li>
                            </ul>
                        </b-col>
                    </b-row>
                </b-container>
            </template>

            <template v-slot:modal-header>
                <h3 v-if="isvalid && browserOk">Benvenuto {{uid}}!</h3>
                <h3 v-else-if="expired || isused || notyet || !browserOk">Attenzione!</h3>
                <h3 v-else> Attendi </h3>
            </template>

            <template v-slot:modal-footer>
                <div v-if="browserOk && isvalid" >
                    <b-button :disabled="!readyToStart" variant="success" @click="startTour">Inizia</b-button>
                </div>
                <div v-else>
                    <b-link to="/home">Torna alla Home</b-link>
                </div>
                <div v-if="browserOk" class="systeminfo">{{ browserinfo }}<br>{{ osinfo }}</div>
            </template>
        </b-modal>

        <b-modal ref="endtour-modal" size="l"
                 no-close-on-esc
                 no-close-on-backdrop
                 hide-header-close
                 ok-only
                 centered>

            <template v-slot:default>
                <b-container fluid class="w-100">
                    <b-row>
                        <b-col>
                            <h3>Il tour è terminato, grazie per aver partecipato!</h3>
                        </b-col>
                    </b-row>
                </b-container>
            </template>

            <template v-slot:modal-header>
                <h3> Grazie! </h3>
            </template>

            <template v-slot:modal-footer>
                <div>
                    <b-link to="/home">Torna alla Home</b-link>
                </div>
            </template>
        </b-modal>

    </b-container>
</template>

<script>
    import moment from "moment";
    moment.locale('IT');

    import Bowser from "bowser";

    import Agora_RTM from './Agora_RTM';
    import Agora_RTC from './Agora_RTC';
    import countDown from './countdown';
    import marzipanoViewer from "./marzipanoViewer";
    import ChatBox from "./ChatBox";
    import UserList from "./UserList";

    export default {
        name: "Client",
        components: {
            marzipanoViewer,
            Agora_RTM,
            Agora_RTC,
            countDown,
            ChatBox,
            UserList
        },
        props: ['ticket'],
        data: function () {
            return {
                uid: '',
                isvalid: false,
                isused: false,
                expired: false,
                channel: null,
                question_wtg: false,
                question_going: false,
                ready: false,
                guideReady: false,
                notyet: '',
                timeofevent: null,
                audioInputDevices: [],
                selectedDevice: null,
                audiotestlevel: 0,
                mictestinterval: null,
                currentnode: '',
                browserinfo: '',
                osinfo: '',
                browserOk: false
            }
        },
        computed:{
            agora_uid: function () {
                return this.uid + '#' + this.ticket;
            },
            readyToStart: function() {
                return this.ready;// && this.guideReady;
            }
        },
        methods:{
            onCommand: function(_json_command){
                if(Object.prototype.hasOwnProperty.call(_json_command, 'command')) {
                    if (_json_command.command === 'NAV') {
                        this.currentnode = this.$refs.pano_view.pano_gotonode(_json_command.node);
                    } else if (_json_command.command === 'VIEW') {
                        this.$refs.pano_view.pano_orient(_json_command.pan, _json_command.tilt);
                    } else if (_json_command.command === 'STARTUSERCOHOST') {
                        if(this.$refs.artc.setCoHost(_json_command.key, _json_command.enable)){
                            this.question_going = _json_command.enable;
                            this.question_wtg = _json_command.enable;
                        }
                    } else if (_json_command.command === 'STOPUSERCOHOST') {
                        if(this.$refs.artc.setCoHost(_json_command.key, _json_command.enable)){
                            this.question_going = _json_command.enable;
                            this.question_wtg = _json_command.enable;
                        }
                    } else if (_json_command.command === 'CONNECT') {
                        this.$refs.artc.connectChannel();
                        this.$refs['welcome-modal'].hide();
                    } else if (_json_command.command === 'DISCONNECT') {
                        this.$refs.artc.leaveChannel();
                    } else if (_json_command.command === 'CHAT') {
                        this.$refs.chatbox.pushMessage(_json_command);
                    } else if (_json_command.command === 'ENDTOUR') {
                        // open modal byebye
                        this.$refs['endtour-modal'].show();
                    }
                }
            },
            registerstream: function(_stream) {
                this.$refs.userlist.setUserStreaming(_stream);
            },
            unregisterstream: function(_stream) {
                this.$refs.userlist.setUserStreaming(_stream, false);
            },
            unregisteruser: function(_id) {
                console.log('++++++++++++++++++++++++', _id);
                if(_id !== this.agora_uid) {
                    this.$refs.userlist.setUserOffline(_id);
                }
            },
            connectRTC (_members){
                if(_members){
                    this.$refs.artc.connectChannel();
                } else {
                    this.$refs.artc.leaveChannel();
                }

                for(const m of _members) {
                    if(m !== this.agora_uid){
                        if(m.indexOf('$') === 0){
                            this.$refs.userlist.addUser(m, m.split('#')[0]);
                        } else {
                            this.$refs.userlist.addUser(m, m.split('#')[0], true);
                        }
                    }
                }
            },
            memberJoin(_id){
                console.log('++++++++++++++++++++++++', _id);
                if(_id !== this.agora_uid){
                    this.$refs.userlist.addUser(_id, _id.split('#')[0]);
                }
            },
            memberLeft(_id){
                console.log('------------------------', _id);
                this.$refs.userlist.setUserOffline(_id);
            },
            endCountdown (){
                if(this.isvalid){
                    this.ready = true;
                    this.resizePanorama();
                }
            },
            startTour () {
                this.stopTestDevice();
                this.$refs.artm.connectChannel();
                this.$refs['welcome-modal'].hide();
            },
            gotDevices (_devices){
                for(const ai of _devices){
                    this.audioInputDevices.push({value: ai, text: ai.label});
                }
            },
            startTestDevice(){
                this.teststream = this.$refs.artc.testDevices("mic-test", this.selectedDevice.deviceId);
                if (this.teststream){
                    this.mictestinterval = setInterval(function(){
                        this.audiotestlevel = this.teststream.getAudioLevel();
                    }.bind(this), 300);
                }
            },
            stopTestDevice(){
                if(this.teststream){
                    this.teststream.close();
                }
                clearInterval(this.mictestinterval);
                this.mictestinterval = null;
            },
            sendChatMessage(_message) {
                let chatmessage = _message;
                chatmessage.command = 'CHAT';
                this.$refs.artm.sendCommand(chatmessage)
            },
            sendinfo(){
                console.log(this.osinfo + ' ' + this.browserinfo, this.$refs.chatbox);
                this.$refs.chatbox.sendChatMessageWithContent(this.osinfo + ' ' + this.browserinfo);
            },
            hostrequest(){
                this.$refs.artm.sendCommand({command:'HOST', user:this.agora_uid})
                this.question_wtg = true;
            },
            resizePanorama(){
                this.$nextTick(() => {
                    if (this.$refs.pano_view) {
                        const div = document.querySelector('#tour-div');
                        this.$refs.pano_view.setSize(div.clientWidth, div.clientHeight);
                    }
                })
            },
            panoIsReady(){
                this.resizePanorama();
                this.currentnode = this.$refs.pano_view.pano_getCurrentNode();
            },
            setGuideReady(){
                this.guideReady = true;
            },
            gracefulclose(){
              window.alert('gergrdg');
            }
        },
        created: function (){
            var docRef = this.$firebase.ticketsCollection.doc(this.ticket)
            docRef.get().then(function(doc) {
                if (doc.exists) {
                    let ticket_details = doc.data();
                    this.isvalid = ticket_details.valid & !ticket_details.used;
                    this.isused = ticket_details.used;

                    //ticket is valid, check if it is its time
                    if (this.isvalid) {
                        let ticketdate = new moment(ticket_details.time_of_event.seconds * 1000)

                        if(ticket_details.doesntexpires === undefined || !ticket_details.doesntexpires){
                            let timediff = ticketdate.diff(moment(), 'minutes');

                            if(timediff > 15){
                                this.notyet = ticketdate.fromNow();
                                this.isvalid = false;
                            } else if (timediff < -60){
                                this.expired = true;
                                this.isvalid = false;
                            }
                        }

                        this.timeofevent = ticketdate.format('YYYY-MM-DD HH:mm:ss');
                        this.uid = ticket_details.user_name;
                        this.channel = ticket_details.event_id;
                    }

                } else {
                    console.log("No such document!");
                }
            }.bind(this)).catch(function(error) {
                console.log("Error getting document:", error);
                this.isvalid = false;
            }.bind(this));
        },
        mounted(){
            this.$nextTick(() => {
                window.addEventListener('resize', this.resizePanorama);
                window.addEventListener('onbeforeunload ', this.gracefulclose);
                this.$refs['welcome-modal'].show();

                const browser = Bowser.getParser(window.navigator.userAgent);

                if (browser.satisfies({chrome: '>80' }) || browser.satisfies({edge: '>80' }) || browser.satisfies({firefox: '>70' }) || browser.satisfies({safari: '>12' })){
                    console.log('Satisfies');
                    this.browserOk = true;
                }

                this.osinfo = browser.getOSName() + ' ' + browser.getOSVersion();
                this.browserinfo = browser.getBrowserName() + ' ' + browser.getBrowserVersion() + ' ' + browser.getEngineName();

            })
        },
        updated(){
            this.$nextTick(() => {
                this.resizePanorama();
            })
        }
    }
</script>

<style scoped>

    .img-bg{
        background-size: cover;
        background-position: center;
        padding:0;
        height:100%;
        overflow:auto;
        background-image:
                linear-gradient(rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)),
                url("../../public/ns_bg.jpg");
        background-blend-mode: lighten;
    }


    .mainrow{
        min-height:80%;
        padding: 0 10px 0 10px;
    }

    .tour-column {
        max-width:1600px;
        max-height:1200px;
        min-width:300px;
        min-height:300px;
    }

    .tour{
        margin-top:5px;
    }

    .tour-container {
        height:calc(100% - 10px);
    }

    #tour-div{
        height: 98%;
        width: 98%;
        margin: auto;
    }

    .panel{
        overflow:hidden;
        background-color:#fff;
        margin:3px;
        padding:5px;
        border-radius:5px;
    }

    .tourbox{
        border: 5px solid transparent;
        outline: 1px solid #000;
        outline-offset: -5px;
    }

    .sidebar-header{
        max-width:100%;
        height:18%;
    }

    .mobile-header{
        height:calc(100% - 5px);
    }

    .toolbox{
        height: 45%;
        max-height: 45%;
    }

    .chatbox{
        height: calc(100% - 35px);
        width: 100%;
        margin-top: 5px;
    }

    .questionbutton{
        width: 100%;
    }

    .help{
        position:absolute;
        top:5px;
        right:5px;
    }

    .sidebar{
        max-width:20%;
        height:100%;
    }

    .sidebar-logo{
        max-width:100%;
        height:100%;
    }

    .tileTitle{
        position: absolute;
        z-index: 1000;
        color: #fff;
        bottom: 3%;
        left: 3%;
        font-weight: bolder;
        text-align: left;
    }

    .systeminfo{
        font-size:0.75em;
        position: absolute;
        width: 95%;
        pointer-events: none;
    }

   @media screen and (max-width: 992px) {

        .sidebar{
            width:100%;
            max-width: 100%;
        }

       /*.tour-container{
           height:100%;
       }*/

        .mainrow{
            /*height:90%;*/
            padding:0;
        }

       .tileTitle{
            font-size: 1.0em;
       }

       /deep/ .modal-body{
           font-size: 0.9em;
           padding: 0.5rem;
       }

       /deep/ .modal-footer{
           font-size: 0.9em;
           padding: 0.5rem;
       }

       h5 {
           text-align: center;
       }

       h3 {
           font-size: 1.3rem;
       }

       .body-content ul {
           padding-inline-start: 20px;
       }
    }

</style>
